export const BACKEND_MAINTENANCE_MESSAGE =
  "backend is under maintenance. Some web features may be temporarily unavailable.";

export const AUTH_SIGN_IN_REQUIRED_MESSAGE =
  "Sign in to access saved providers and chat history.";

export const AUTH_SESSION_RECONNECT_MESSAGE =
  "Your session has expired. Sign in again to reconnect secure providers and chat history.";
